import React from 'react';
import { Shield, CheckCircle, BanknoteIcon } from 'lucide-react';
export function PaymentIcons() {
  return <div className="w-full mt-4" data-id="element-209">
      {/* Payment method icons */}
      <div className="flex justify-center gap-4 mb-6" data-id="element-210">
        {/* Shop Pay */}
        <div className="bg-[#5a31f4] text-white py-2 px-6 rounded-md" data-id="element-211">
          <span className="font-medium" data-id="element-212">shop</span>
        </div>
        {/* Amazon Pay */}
        <div className="bg-[#ffd814] py-2 px-4 rounded-md flex items-center" data-id="element-213">
          <span className="font-medium text-black" data-id="element-214">amazon</span>
          <span className="font-medium text-black ml-1" data-id="element-215">pay</span>
        </div>
        {/* Google Pay */}
        <div className="bg-black text-white py-2 px-4 rounded-md flex items-center" data-id="element-216">
          <span className="text-[#4285f4] font-bold mr-1" data-id="element-217">G</span>
          <span className="font-medium" data-id="element-218">Pay</span>
        </div>
      </div>
      {/* Security badges */}
      <div className="flex justify-center items-center gap-6 text-[#4b8063]" data-id="element-219">
        <div className="flex items-center" data-id="element-220">
          <Shield size={20} className="mr-1.5" data-id="element-221" />
          <span className="text-sm font-medium" data-id="element-222">Secure</span>
        </div>
        <div className="flex items-center" data-id="element-223">
          <CheckCircle size={20} className="mr-1.5" data-id="element-224" />
          <span className="text-sm font-medium" data-id="element-225">Guaranteed</span>
        </div>
        <div className="flex items-center" data-id="element-226">
          <BanknoteIcon size={20} className="mr-1.5" data-id="element-227" />
          <span className="text-sm font-medium" data-id="element-228">Trusted</span>
        </div>
      </div>
    </div>;
}